import React, { useContext, useState } from "react";
import cfe from "../../../services/cfe";
import AppContext from "../../../container/context";
import Form from "../../../components/form";

export default function Inserir(props) {
  const { notification } = useContext(AppContext);
  const [dados, setDados] = useState({});

  const salvar = (form) => {
    setDados(form);
    cfe
      .put("admin/instituicoes/inserir", form)
      .then(() => {
        notification("success", "Instituição inserida com sucesso.");
        props.history.goBack();
        setDados({});
      })
      .catch((err) => {
        console.log(err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Razão social inválida");
          case 2:
            return notification("error", "Nome fantasia inválido");
          case 3:
            return notification("error", "CNPJ inválido");
          case 4:
            return notification("error", "CNPJ já cadastrado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDados = {
    title: "Nova instituição",
    form: {
      nomeFantasia: {
        label: "Nome fantasia",
        type: "text",
        required: true,
        space: 6,
        value: dados.nomeFantasia,
      },
      razaoSocial: {
        label: "Razão social ",
        type: "text",
        required: true,
        space: 6,
        value: dados.razaoSocial,
      },
      emailFinanceiro: {
        label: "Email admin/financeiro",
        type: "text",
        required: true,
        space: 6,
        value: dados.emailFinanceiro,
      },
      CNPJ: {
        label: "CNPJ",
        type: "text",
        required: true,
        space: 6,
        value: dados.CNPJ,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
    close: true,
    history: props.history,
  };

  return (
    <>
      {" "}
      <Form formData={fDados} />
    </>
  );
}
